import { createVNode, render } from 'vue';
import PdfPasswordModal from '@/components/pdf/PdfPasswordModal.vue';

/**
 * Shows the password modal without requiring every view to mount it.
 * Resolves with the entered password, or null if the user cancelled.
 */
export const promptPdfPassword = (incorrect: boolean): Promise<string | null> =>
  new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const close = (value: string | null) => {
      render(null, container);
      container.remove();
      resolve(value);
    };

    const vnode = createVNode(PdfPasswordModal, {
      incorrect,
      onSubmit: (password: string) => close(password),
      onCancel: () => close(null),
    });
    render(vnode, container);
  });
